import React from "react";
import { string, func } from "prop-types";

import "./profileHeadline.m.css";

const ProfileHeadline = ({ title = "", arrowClick, type = "", lang = "" }) => (
  <div styleName="profile-headline" className="profile-headline">
    {type !== "edit-profile" && type !== "change-password" && arrowClick ? (
      <span onClick={arrowClick} styleName="icon"></span>
    ) : null}
    <span styleName={`title ${lang}-title`}>{title}</span>
  </div>
);

ProfileHeadline.propTypes = {
  title: string,
  arrowClick: func,
  type: string,
  lang: string,
};

export default ProfileHeadline;
